import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { store } from './utils/configureStore';

const AUTHENTICATED_PATH =
  process.env.REACT_APP_AUTHENTICATED_PATH || '/api/homepage';

/**
 * Check for session and get login URL from backend if needed
 */
const checkSessionAndRedirect = async () => {
  // Normalize path so '/homepage' and '/homepage/' are treated the same.
  const currentPath = window.location.pathname.replace(/\/$/, '') || '/';

  // If we're on protected homepage routes, render app directly.
  if (currentPath === '/homepage' || currentPath === '/api/homepage') {
    console.log('✓ Already on protected homepage route, rendering app');
    return true; // Render app
  }

  const urlParams = new URLSearchParams(window.location.search);
  const errorParam = urlParams.get('error');
  if (errorParam) {
    console.error(
      '❌ OAuth error:',
      errorParam,
      urlParams.get('details') || urlParams.get('message')
    );
    // Could show error UI here, for now just log it
  }

  // ALWAYS call backend to check authentication status
  console.log('🔍 Calling backend /api/idmauth to check authentication...');
  try {
    // Use relative URL since frontend and backend are on the same port
    const apiUrl = process.env.REACT_APP_API_URL;
    const fullUrl = `${apiUrl}/idmauth`;
    console.log('📡 Calling:', fullUrl);

    const response = await fetch(fullUrl, {
      method: 'GET',
      credentials: 'include', // Send cookies
      headers: {
        Accept: 'application/json'
      }
    });

    const data = await response.json();
    console.log('✅ Backend response:', data);

    // If authenticated, render app on current page.
    // Avoid forcing '/homepage' because some prod hosts don't rewrite deep SPA routes.
    if (data.isAuthenticated) {
      console.log('✓ User is authenticated, rendering app');
      return true;
    }

    // Not authenticated - redirect to login
    if (data.loginUrl) {
      console.log(
        '🔀 User not authenticated, redirecting to login:',
        data.loginUrl
      );
      window.location.href = data.loginUrl;
      return false; // Don't render app
    }
  } catch (err) {
    console.error('❌ Failed to call /api/idmauth:', err);

    window.location.href = '/';
    return false;
  }

  return false;
};

// Render appropriate component based on URL and session state
(async () => {
  const shouldRender = await checkSessionAndRedirect();

  if (shouldRender) {
    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
      <React.StrictMode>
        <Provider store={store}>
          <App />
        </Provider>
      </React.StrictMode>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
